import { type FC } from 'react';

import { TwoColumnRow } from '@vakantiesnl/components/src/atoms/TwoColumnRow';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { type RowContent } from '@vakantiesnl/types';

import { useCustomStyles } from './TwoColumnTable.style';

type TwoColumnTableProps = {
	/** Content to render in the table mapped per row */
	tableContent: RowContent[];
	contentColumnRatio?: number;
	title?: string;
	/** Align the content in the right column */
	centerOrFlexStart?: 'center' | 'flex-start';
};

export const TwoColumnTable: FC<TwoColumnTableProps> = ({
	title,
	tableContent,
	contentColumnRatio,
	centerOrFlexStart = 'center',
}) => {
	const { classes } = useCustomStyles();
	const { isMobile } = useBreakpoints();

	return (
		<>
			{title && (
				<Typography as="h5" variant={isMobile ? 'headingXs' : 'headingSm'}>
					{title}
				</Typography>
			)}
			<table className={classes.table}>
				<tbody>
					{tableContent.map((rowContent, i) => (
						<TwoColumnRow
							contentColumnRatio={contentColumnRatio}
							rowContent={rowContent}
							key={`${rowContent.rowTitle}-${i}`}
							centerOrFlexStart={centerOrFlexStart}
						/>
					))}
				</tbody>
			</table>
		</>
	);
};
